@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    @if (readOnlyDisplayValue; as displayValue) {
      <ix-input
        [value]="displayValue"
        [readonly]="true"
        class="w-100"
        id="{{ attribute.name }}">
      </ix-input>
    } @else {
      <ix-date-input
        [formControl]="control"
        [invalidText]="createInvalidText(control)"
        [ngClass]="{'ix-invalid': control.errors}"
        [format]="attribute.format || 'yyyy-LL-dd'"
        [locale]="currentLocale()"
        class="w-100"
        id="{{ attribute.name }}">
      </ix-date-input>
    }
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
